import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';

@Directive({
  selector: '[tooltip]',
  standalone: true
})
export class TooltipDirective implements OnDestroy {
  @Input() tooltip = ''; // The text for the tooltip to display
  @Input() delay?; // Optional delay input, in ms
  @Input() positionTop = false; //optional: for positioning tooltip above and not under

  private myPopup;
  private timer;

  constructor(private el: ElementRef) {}

  ngOnDestroy(): void {
    if (this.myPopup) {
      this.myPopup.remove();
    }
  }

  @HostListener('mouseenter') onMouseEnter() {
    // Get the middle of the element
    let x = this.el.nativeElement.getBoundingClientRect().left + this.el.nativeElement.offsetWidth / 2;
    // Get the bottom of the element, plus a little extra
    let y = this.el.nativeElement.getBoundingClientRect().top + this.el.nativeElement.offsetHeight + 6;
    if (this.positionTop) {
      //if tooltip needs to be displayed higher
      y = this.el.nativeElement.getBoundingClientRect().top - this.el.nativeElement.offsetHeight * 4;
    }

    if (this.delay != null) {
      this.timer = setTimeout(() => {
        this.createTooltipPopup(x, y);
      }, this.delay);
    } else {
      this.createTooltipPopup(x, y);
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.timer) clearTimeout(this.timer);
    if (this.myPopup) {
      this.myPopup.remove();
    }
  }

  private createTooltipPopup(x: number, y: number) {
    let popup = document.createElement('div');
    popup.innerHTML = this.tooltip;
    popup.setAttribute('class', 'tooltip-container');
    popup.style.top = y.toString() + 'px';
    popup.style.left = x.toString() + 'px';
    document.body.appendChild(popup);
    this.myPopup = popup;
  }
}
